import { SVGProps, Ref, forwardRef } from 'react';

export const PinCrossedOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m19.918 9.841-3.133 3.133-1.272-1.273 3.133-3.132-3.224-3.223-3.133 3.132-1.272-1.272 3.133-3.132-1.803-1.802L13.619 1l9.375 9.372-1.273 1.272zm-4.584 6.766L21.728 23 23 21.728 2.276 1.004 1.004 2.276l6.38 6.381-.11-.016a6.12 6.12 0 0 0-4.997 1.544c-.442.404-.854.845-1.277 1.268l5.138 5.136-5.134 5.132 1.272 1.273L7.41 17.86l5.128 5.126c.423-.423.863-.834 1.268-1.276a6.12 6.12 0 0 0 1.544-4.996zm-2.12-2.121-3.71-3.709-2.485-.355a4.32 4.32 0 0 0-3.468 1.037l8.98 8.978a4.32 4.32 0 0 0 1.037-3.467z"
            fill="currentColor"
        />
    </svg>
));
PinCrossedOutlinedSize24Glyph.displayName = 'PinCrossedOutlinedSize24Glyph';
